import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-details-skeleton',
  templateUrl: './product-details-skeleton.component.html',
  styleUrls: ['./product-details-skeleton.component.scss']
})
export class ProductDetailsSkeletonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
